import React from "react";
import { ClassNameProps, Column, Heading, HeadingLevel, Row, StyleProps } from "@hex-insights/core";
import { Tile } from "../../../../../Components/Tile";
import styles from "./styles.module.css";

export type LessonPlansAggregrateReportTileProps = {
	headingLevel?: HeadingLevel;
} & Partial<ClassNameProps & StyleProps>;

export function LessonPlansAggregrateReportTile({
	headingLevel = 2,
	className,
	style,
}: LessonPlansAggregrateReportTileProps) {
	return (
		<Tile className={className} style={style}>
			<Tile.Header>
				<Heading level={headingLevel} noMargin>
					Lesson Plans
				</Heading>
			</Tile.Header>
			<Tile.Body>
				<Row justify="spaced-center" horizontalSpacing="2.5rem">
					<DayProgressBar label="M" progress={0.4} />
					<DayProgressBar label="T" progress={0.6} />
					<DayProgressBar label="W" progress={0.8} />
					<DayProgressBar label="T" progress={0.2} />
					<DayProgressBar label="F" progress={0.9} />
				</Row>
			</Tile.Body>
		</Tile>
	);
}

type DayProgressBarProps = {
	label: string;
	progress: number;
};

function DayProgressBar({ label, progress }: DayProgressBarProps) {
	let progressColor = "var(--theme-colors__green)";
	if (progress < 0.33) {
		progressColor = "var(--theme-colors__orange)";
	} else if (progress < 0.75) {
		progressColor = "var(--theme-colors__yellow)";
	}

	return (
		<Column justify="spaced-start" align="center" verticalSpacing="1rem">
			<span className={styles["day-progress-bar__label"]}>{label}</span>
			<div
				className={styles["day-progress-bar__bar"]}
				style={{ "--progress": progress, "--progress-color": progressColor } as React.CSSProperties}
			></div>
		</Column>
	);
}
